import { gql } from "@/__generated__/gql";

export const CREATE_BULK_MESSAGE_MUTATION = gql(`
 mutation CreateBulkMessage(
  $createdById: ID!
  $draft: Boolean!
  $filters: BulkMessageFilterInput!
  $messageParts: [MessagePartInput!]
  $name: String!
  $organizationId: ID!
  $sendOption: BulkMessageSendOptionInput
  $sender: BulkMessageSenderInput
) {
  createBulkMessageMutation(input: {
    createdById: $createdById,
    draft: $draft,
    filters: $filters,
    messageParts: $messageParts,
    name: $name,
    organizationId: $organizationId,
    sender: $sender,
    sendOption: $sendOption
  }) {
    bulkMessage {
      id
      audienceReach(first: 6) {
        edges {
          node {
            id
            uuid
            firstName
            lastName
            profilePhoto {
              id
              url(size: 48)
            }
          }
          cursor
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        totalCount

      }
      draft
    }
    errors {
      title
      message
    }
  }
}
`);
